import { isMobile, getUA } from 'react-device-detect';
import { STORAGE_KEYS } from '_constants/storage';
import { storeLocalValue, restoreLocalValue, storeSessionValue } from '_helpers/storage';

const buildClickURLObject = (query = {}) => {
  const { gclid, source, keyword, adAccount } = query;

  const url = window.location.href;
  const page = url.split('?')[0].replace(/\/?$/, '') || '/';

  return {
    url,
    page,
    ...(gclid && { clid: gclid.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(source && { source: source.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(keyword && { keyword: keyword.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(adAccount && { adAccount: adAccount.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
  };
};

export const createClickBody = (location) => {
  const { query = {}, pathname = '' } = location;
  const { gclid, source, keyword, adAccount } = query;

  if (gclid) {
    try { localStorage.setItem('gclid', gclid.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')); } catch (e) {}
  }
  if (source) {
    try { localStorage.setItem('source', source.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')); } catch (e) {}
  }
  if (keyword) {
    try { localStorage.setItem('keyword', keyword.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')); } catch (e) {}
  }
  if (adAccount) {
    try { localStorage.setItem('adAccount', adAccount.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')); } catch (e) {}
  }

  const click = {};
  click.requestUri = window.location.href;

  if (gclid || keyword || source || adAccount) {
    try { localStorage.setItem('requestUri', window.location.href); } catch (e) {}
  }
  if (localStorage?.getItem('requestUri')?.includes(window.location.href)) {
    click.requestUri = localStorage.getItem('requestUri');
  }

  click.device = isMobile && !getUA.includes('Intel') ? 'MOBILE' : 'DESKTOP';

  const fingerprint = restoreLocalValue(STORAGE_KEYS.fingerprint);
  if (fingerprint) click.fingerprint = fingerprint;

  let pageType = 'presellPage';
  if (
    pathname.includes('registration-trademark') ||
    pathname.includes('comprehensive-search-report') ||
    pathname.includes('statement-of-use-report')
  ) pageType = 'leadPage';
  else if (pathname.includes('payment')) pageType = 'checkoutPage';
  else if (pathname.includes('thankyou')) pageType = 'thankyouPage';
  else if (pathname.includes('upsell')) pageType = 'upsellPage1';

  click.pageType = pageType;

  if (localStorage?.getItem('crmSessionId') && pageType !== 'presellPage') {
    click.crmSessionId = localStorage.getItem('crmSessionId');
  }

  return click;
};

export const initVisitTracking = (location) => {
  if (typeof window === 'undefined') return;

  const query = location.query || {};
  const { gclid, source, keyword, adAccount } = query;
  const hasTrackingParams = gclid || source || keyword || adAccount;

  if (hasTrackingParams) {
    storeSessionValue(STORAGE_KEYS.saleURL, buildClickURLObject(query));
  }

  if (restoreLocalValue(STORAGE_KEYS.firstClickURL)) return;

  storeLocalValue(STORAGE_KEYS.firstClickURL, buildClickURLObject(query));
};
